import { Component, OnInit } from "@angular/core";
import { Article } from "../model/article.model";
import { ArticleRepository } from "../model/article.repository";
import { Router } from "@angular/router";
import { ActivatedRoute} from "@angular/router";
import { Search } from '../model/search.model';
import { ValueStoreService } from '../service/value-store.service';
import { ComponentLiteralNavName, LectureType, getSkillLevelValue, SkillLevel } from "../service/constants";



@Component({
  selector: "app-article",
  templateUrl: "article.component.html",
  styleUrls: ["article.component.css"]
})
export class ArticleComponent implements OnInit{
  public selectedSubCategory = "";
  public articlesPerPage = 2;

  public foundationPaginationNum = 1;
  public intermediatePaginationNum = 1;
  public advancedPaginationNum = 1;

  public articlesList: Article[] = [];
  public foundationArticlesList: Article[] = [];
  public intermediateArticlesList: Article[] = [];
  public advancedArticlesList: Article[] = [];

  public LocalLectureType;
  public localSkillLevel;

  constructor(private repository: ArticleRepository, private router: Router, private activatedRoute: ActivatedRoute,
    private searchString: Search, private valueStoreService: ValueStoreService) {
  }

  ngOnInit(): void {
    this.LocalLectureType = LectureType;
    this.localSkillLevel = SkillLevel;
    this.getRemoteArticles();
    this.setPaginationNum();
  }

  /**
   * Set initial pagination nums to 1 or historic nums if exist
   */
  setPaginationNum(): void {
    //foundation num
    if (this.valueStoreService.getRecentPaginationNum(this.localSkillLevel.Beginner) > 1) {
      this.foundationPaginationNum =
      this.valueStoreService.getRecentPaginationNum(this.localSkillLevel.Beginner);
      this.valueStoreService.setRecentPaginationNum(this.localSkillLevel.Beginner, 1)
    }

     //intermediate num
     if (this.valueStoreService.getRecentPaginationNum(this.localSkillLevel.Intermediate) > 1) {
      this.intermediatePaginationNum =
      this.valueStoreService.getRecentPaginationNum(this.localSkillLevel.Intermediate);
      this.valueStoreService.setRecentPaginationNum(this.localSkillLevel.Intermediate, 1)
    }

     //advanced num
     if (this.valueStoreService.getRecentPaginationNum(this.localSkillLevel.Advanced) > 1) {
      this.advancedPaginationNum =
      this.valueStoreService.getRecentPaginationNum(this.localSkillLevel.Advanced);
      this.valueStoreService.setRecentPaginationNum(this.localSkillLevel.Advanced, 1)
    }
  }

  getRemoteArticles() {
    this.selectedSubCategory = this.activatedRoute.snapshot.params["subcategory"] ? this.activatedRoute.snapshot.params["subcategory"] : this.searchString.category;
    if(this.activatedRoute.snapshot.params["subcategory"]) {
      this.repository.getArticlesBySubCategory(this.selectedSubCategory).subscribe(data => {
        this.articlesList = data;

        this.foundationArticlesList = this.groupArticlesByLevel(getSkillLevelValue(SkillLevel.Beginner));
        this.intermediateArticlesList = this.groupArticlesByLevel(getSkillLevelValue(SkillLevel.Intermediate));
        this.advancedArticlesList = this.groupArticlesByLevel(getSkillLevelValue(SkillLevel.Advanced));

      });
    }
  }

  groupArticlesByLevel(skillLevel?: number): Article[] {
      return this.articlesList.filter(article=>{
       return article.level == skillLevel
      });
  }

  getFoundationalLevelArticles(): Article[] {
    let pageIndex = (this.foundationPaginationNum -1) * this.articlesPerPage;
    if(this.activatedRoute.snapshot.params["subcategory"]) {
        if (this.selectedSubCategory == this.activatedRoute.snapshot.params["subcategory"] ) {
          return this.foundationArticlesList?.slice(pageIndex, pageIndex + this.articlesPerPage);
        } else {
          this.getRemoteArticles();
        }
     }
  }

  /**
   * No need to check all conditions as in getFoundationalLevelArticles() as
   * doing so will repeat redundant checks and api calls.
   *
   */
  getIntermediateLevelArticles(): Article[] {
    let pageIndex = (this.intermediatePaginationNum -1) * this.articlesPerPage;
    return this.intermediateArticlesList?.slice(pageIndex, pageIndex + this.articlesPerPage);
  }

  /**
   * No need to check all conditions as in getFoundationalLevelArticles() as
   * doing so will repeat redundant checks and api calls.
   *
   */
   getAdvancedLevelArticles(): Article[] {
    let pageIndex = (this.advancedPaginationNum -1) * this.articlesPerPage;
    return this.advancedArticlesList?.slice(pageIndex, pageIndex + this.articlesPerPage);
  }

  get subCategories(): string[] {
    return this.repository.getSubCategories();
  }

  changeCategory(newCategory?: string) {
    this.selectedSubCategory = newCategory;
  }

  changeFounPagNum(newPage: number){
    this.foundationPaginationNum = newPage;
  }

  changeIntPagNum(newPage: number){
    this.intermediatePaginationNum = newPage;
  }

  changeAdvPagNum(newPage: number){
    this.advancedPaginationNum = newPage;
  }

  get pageCountFoundation(): number {
    return Math.ceil(this.foundationArticlesList.length / this.articlesPerPage);
  }

  get pageCountIntermediate(): number {
    return Math.ceil(this.intermediateArticlesList.length / this.articlesPerPage);
  }

  get pageCountAdvanced(): number {
    return Math.ceil(this.advancedArticlesList.length / this.articlesPerPage);
  }
  /*
  get pageNumbers(): number[] {
    return Array(Math.ceil(this.repository.getProducts(this.selectedCategory).length / this.articlesPerPage)).fill(0).map((x,i) => i + 1);
  }
  */


  getWindowInnerWidth():number {
    return window.innerWidth;
  }

  getWindowInnerHeight():number {
    return window.innerHeight;
  }

  getMainContainerHeight():number {
    return document.querySelector('#main-container').clientHeight;
  }

  getOptimalMainContainerHeight():string {
    if (this.getMainContainerHeight() >= this.getWindowInnerHeight()) {
      let pixel = this.getMainContainerHeight();
      return pixel+"px";
    } else {
      //footer is 200px and nav is around 50px
      let pixel = (this.getWindowInnerHeight() - (200+this.getMainContainerHeight())) +this.getMainContainerHeight();
      return this.getWindowInnerHeight()+200+"px";
    }
  }


  navigateToArticleDetail(skillLevel: string, articleId: number, paginationNum: number) {
   this.valueStoreService.setRecentPaginationNum(skillLevel, paginationNum);
   this.valueStoreService.setParamValue(this.selectedSubCategory);
   this.valueStoreService.setPreviousPage(ComponentLiteralNavName.CompArticle);
   this.router.navigate([ComponentLiteralNavName.CompArticleDetail, articleId]);
  }
}
